import React from 'react'

import { UnknownObject } from 'src/utils/reactTypes'

export const ShareIcon: React.FC<UnknownObject> = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.6665 11V18.3333C3.6665 18.8196 3.85966 19.2859 4.20347 19.6297C4.54729 19.9735 5.01361 20.1667 5.49984 20.1667H16.4998C16.9861 20.1667 17.4524 19.9735 17.7962 19.6297C18.14 19.2859 18.3332 18.8196 18.3332 18.3333V11"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.6668 5.50004L11.0002 1.83337L7.3335 5.50004"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 1.83337V13.75"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
